import type { Integer } from '@hc-frontend/core-types';
import { ProductType } from '@hc-frontend/core-types';

const LEAD_PRODUCT_TYPE_IDS: Record<ProductType, Integer> = {
  [ProductType.Enum.HEALTH]: 4,
  [ProductType.Enum.MEDICARE]: 3,
  [ProductType.Enum.MEDICARE_ADVANTAGE]: 3,
  [ProductType.Enum.LIFE_INSURANCE]: 2,
};

/**
 * Maps a frontend {@link ProductType} to the numeric `productTypeId` used by Lead Storage.
 *
 * Medicare and Medicare Advantage share the same Lead Storage product type.
 *
 * @param productType - The frontend product type.
 * @returns The Lead Storage `productTypeId` for the given product type.
 */
export function productTypeToLeadProductType(productType: ProductType) {
  return LEAD_PRODUCT_TYPE_IDS[productType];
}
